import CountUp from 'react-countup';
export default function HomeFiveCounter(){
    return(
        <section class="counter-area pt-110 pb-85 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30 home-5">
			<div class="container">
				<div class="row align-items-center text-center">
					<div class="col-lg-4 col-md-4">
						<div class="rts-counter-list">
							<div class="counter-icon">
								<i class="fas fa-briefcase"></i>
							</div>
							<div class="count-text2 text-left mb-30 mt-xs-20">
								<h3><span class="counter"><CountUp end={27} /></span>+</h3>
								<h5>Years of Experience</h5>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-4">
						<div class="rts-counter-list">
							<div class="counter-icon">
								<i class="fas fa-code"></i>
							</div>
							<div class="count-text2 text-left mb-30 mt-xs-20">
								<h3><span class="counter"><CountUp end={3921} /></span>+</h3>
								<h5>IT Problems Solved</h5>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-4">
						<div class="rts-counter-list">
							<div class="counter-icon">
								<i class="fas fa-thumbs-up"></i>
							</div>
							<div class="count-text2 text-left mb-30 mt-xs-20">
								<h3><span class="counter"><CountUp end={199} /></span>+</h3>
								<h5>Satisfied Clients</h5>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}